import React from 'react';
import { DataList, CustomModal, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import useDashboardActions from 'pages/userProfile/useUserProfileActions';
import { LIST_ENTITY_NAMES } from 'constant';
import { Button, KIND, SIZE, SHAPE } from 'baseui/button';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';

const InvoiceGenerationList: React.FC<{}> = () => {
	const {
		getAllInvoiceData,
		handleFilterModalOpen,
		showLoader,
		forceUpdate,
		pageNumber,
		filters,
		jumpBack,
		jumpNext,
		selectColumnConfigs,
		setShowLoader
	} = useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, { setShowLoader, filters });
	const actions = getActionList();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				<div
					className={css({
						display: 'flex',
						justifyContent: 'center',
						gap: '5px'
					})}>
					<div
						className={css({
							fontSize: '16px',
							fontWeight: 'bold',
							width: '200px'
						})}>
						Game: {filters?.gameName?.toUpperCase() || ''}
					</div>
				</div>
				<Button
					kind={KIND.primary}
					size={SIZE.compact}
					onClick={() => {
						handleFilterModalOpen();
					}}>
					Change Filters
				</Button>
				<div title='download' className={css({ padding: '6px 200px' })}>
					{pageNumber.currPage > 0 && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpBack();
							}}>
							← Prev Page
						</Button>
					)}
					{pageNumber.nextPage !== null && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpNext();
							}}>
							Next Page →
						</Button>
					)}
				</div>
			</div>
			<DataList
				fetchData={getAllInvoiceData}
				columnConfigs={selectColumnConfigs()}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.INVOICE_GENERATION}
				height='calc(100vh - 220px)'
				filterable={false}
				searchable={false}
				globalForceUpdate={forceUpdate}
			/>
			<CustomModal />
		</>
	);
};

export default InvoiceGenerationList;
